import { useState, useEffect } from 'react';

const couponCodes = ['JOYAGOO10', 'SAVE15NOW', 'JOYSHIP2026', 'NEWUSER20'];

const HeroSection = () => {
  const [copied, setCopied] = useState(false);
  const [codeIndex, setCodeIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCodeIndex((prev) => (prev + 1) % couponCodes.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(couponCodes[codeIndex]).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="relative pt-16 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-orange-50 via-white to-amber-50"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-100 rounded-full opacity-30 -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-100 rounded-full opacity-40 translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Left Content */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-orange-100 text-orange-600 text-xs font-semibold rounded-full mb-6">
              <i className="ri-fire-line"></i>
              Updated April 2026 – New Codes Available
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-4">
              Get Exclusive
              <span className="block text-orange-500">JoyaGoo Coupons</span>
              &amp; Save Big
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              Discover the latest <strong>joyagoo coupon codes</strong>, promo deals, and exclusive discounts. Save up to 50% on shoes, hoodies, jerseys, and more at the best replica fashion store.
            </p>

            {/* Coupon Code Box */}
            <div className="flex flex-col sm:flex-row items-center gap-3 mb-8 justify-center lg:justify-start">
              <div className="flex items-center gap-3 bg-white border-2 border-dashed border-orange-300 rounded-xl px-5 py-3 min-w-[200px]">
                <i className="ri-coupon-3-line text-orange-500 text-xl"></i>
                <span className="font-mono font-bold text-gray-900 text-lg tracking-widest">{couponCodes[codeIndex]}</span>
              </div>
              <button
                onClick={handleCopy}
                className="flex items-center gap-2 px-5 py-3 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className={`${copied ? 'ri-checkbox-circle-line' : 'ri-file-copy-line'}`}></i>
                {copied ? 'Copied!' : 'Copy Code'}
              </button>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <a
                href="https://repsw2c.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-gray-900 text-white font-bold text-base rounded-xl hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-shopping-bag-3-line"></i>
                joyagoo coupon
              </a>
              <a
                href="https://repsw2c.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-orange-500 text-white font-bold text-base rounded-xl hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Buy It Now
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap items-center gap-5 mt-8 justify-center lg:justify-start">
              {[
                { icon: 'ri-shield-check-line', text: 'Verified Codes' },
                { icon: 'ri-refresh-line', text: 'Daily Updates' },
                { icon: 'ri-truck-line', text: 'Free Shipping Deals' },
              ].map((badge) => (
                <div key={badge.text} className="flex items-center gap-1.5 text-sm text-gray-500">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${badge.icon} text-orange-400`}></i>
                  </div>
                  <span>{badge.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="flex-1 w-full max-w-lg">
            <div className="relative">
              <div className="w-full h-[380px] md:h-[440px] rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/313d549444082e3e28a3de9e66d2006a.jpg"
                  alt="JoyaGoo Fashion Collection - Best Coupon Deals"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Floating Badge */}
              <div className="absolute -bottom-4 -left-4 bg-white rounded-xl px-4 py-3 shadow-md border border-gray-100">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-orange-100 rounded-lg">
                    <i className="ri-percent-line text-orange-500"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Max Discount</p>
                    <p className="font-bold text-gray-900 text-sm">Up to 50% OFF</p>
                  </div>
                </div>
              </div>
              <div className="absolute -top-4 -right-4 bg-orange-500 text-white rounded-xl px-4 py-3">
                <p className="text-xs font-medium">Active Codes</p>
                <p className="font-bold text-xl">20+</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
